// extracted by mini-css-extract-plugin
export var aboutVision = "AboutVision-module--aboutVision--GUD5A";
export var aboutButtonsContainer = "AboutVision-module--aboutButtonsContainer--Dp1Is";
export var active = "AboutVision-module--active--zrZuh";
export var aboutInfoContainer = "AboutVision-module--aboutInfoContainer--uR7sZ";
export var websiteButton = "AboutVision-module--websiteButton--PzrV3";